import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['rows', 'row', 'template'];

  connect() {
    this.renumber = this.renumber.bind(this);
    this.form = this.element.closest('form');
    this.form?.addEventListener('submit', this.renumber);
  }

  disconnect() {
    this.form?.removeEventListener('submit', this.renumber);
  }

  addRow() {
    const html = this.templateTarget.innerHTML.replace(/NEW_THREAD/g, `${Date.now()}${Math.floor(Math.random() * 1000)}`);

    this.rowsTarget.insertAdjacentHTML('beforeend', html);
    this.renumber();
    this.toggleEmpty();
    this.rowsTarget.lastElementChild?.querySelector('.choices, select')?.focus();
  }

  removeRow(event) {
    const row = event.currentTarget.closest('[data-thread-picker-target="row"]');
    const destroyField = row?.querySelector('input[data-thread-picker-destroy]');

    if (!row) return;

    if (destroyField) {
      destroyField.value = '1';
      // The `hidden` attribute loses to the row's `display` class.
      row.classList.add('hidden');
    } else {
      row.remove();
    }
    this.renumber();
    this.toggleEmpty();
  }

  renumber() {
    this.visibleRows.forEach((row, position) => {
      row.querySelector('input[data-thread-picker-position]').value = position;
    });
  }

  toggleEmpty() {
    this.rowsTarget.classList.toggle('hidden', this.visibleRows.length === 0);
  }

  get visibleRows() {
    return this.rowTargets.filter((row) => !row.classList.contains('hidden'));
  }
}
